export const POPOVER_CONTAINER_ID = 'popoverContainer';

/**
 * Returns the popover container for poppers. Example: AddResolvers.jsx
 *
 * If your popper hides or shows too early during page dimension change (i.e. narrowing the page), maybe its parent is wrong. It may be:
 *   1. too deep in DOM tree, hence got scrolled out of view and got hidden too early, or
 *   2. too shallow in DOM tree hence got scrolled into view and got hidden too late
 * Changing your popover parent using a different ID (or null to use document) may fix the issue.
 *
 * @param {string|null} id - The HTML ID for the element. Passing '' or null will bypass the default parameter.
 * @returns {HTMLBodyElement} - The queried HTML element; will be document if
 *   1. The id is '' or null (but not undefined; that'll use POPOVER_CONTAINER_ID)
 *   2. The queried element does not exist in DOM
 */
export const getPopoverContainer = (id = POPOVER_CONTAINER_ID) => {
  const body = document.querySelector('body');

  if (!id) return body;
  return document.querySelector(`#${id}`) || body;
};
